import { render, staticRenderFns } from "./ConfigValueAddEdit.vue?vue&type=template&id=62d0a41e&"
import script from "./ConfigValueAddEdit.vue?vue&type=script&lang=js&"
export * from "./ConfigValueAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports